import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-31147a67")

_pushScopeId("data-v-31147a67")
const _hoisted_1 = { class: "masonry-with-columns" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "grid-sizer w-full md:w-2/4 lg:w-1/3 xl:w-1/4" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
      return (_openBlock(), _createBlock(_Fragment, null, [
        item
          ? (_openBlock(), _createBlock("div", {
              key: index,
              class: "grid-item w-full md:w-2/4 lg:w-1/3 xl:w-1/4"
            }, [
              _renderSlot(_ctx.$slots, "default", item)
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 256))
  ]))
})